<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";
    import HoverTipsView from "../Message/HoverTipsView.svelte";

    export let label = null;
    export let labelMinWidthEm = 12;
    export let tipsMessage = null; // 常に表示されている注意書き
    export let errorMessage = null;

    export let hoverTipsMessage = null; // マウスオーバー時のみ表示される注意書き
    export let disableMessageAreaPaddingLeft = false;

    $: messageAreaStyle = (() => {
        let style = '';
        if (!disableMessageAreaPaddingLeft) {
            style += `padding-left: calc(${labelMinWidthEm}em + 12px);`;
        }

        return style;
    })();


    let rootElement = null;

    onMount(() => {
    });

    $: isRequired = (() => {
        if (rootElement == null) {
            return false;
        }
        const requiredElement = rootElement.querySelector('[required]');
        if (requiredElement != null) {
            return true;
        } else {
            return false;
        }
    })();

</script>


<span class="input-area-view" bind:this={rootElement}>
    <div class="label-input-area">
        <span class="label-area"
              style={`min-width: ${labelMinWidthEm}em;`}
        >
            { label }

            {#if hoverTipsMessage != null}
                <HoverTipsView message={hoverTipsMessage}/>
            {/if}

            {#if isRequired}
                <span class="required-sign">必須</span>
            {/if}
        </span>
        <span class="input-area">
            <slot/>
        </span>
    </div>
    <div class="message-area" style={messageAreaStyle}>
        {#if !ValueUtil.isEmpty(tipsMessage)}
            <div class="tips-message message">
                  <div class="sign">
                    <FontAwesomeView icon="circle-info"/>
                </div>
                <div class="message">
                    {tipsMessage}
                </div>
            </div>
        {/if}

        {#if !ValueUtil.isEmpty(errorMessage)}
            <div class="error-message message">
                <div class="sign">
                    <FontAwesomeView icon="circle-exclamation"/>
                </div>
                <div class="message">
                    {errorMessage}
                </div>
            </div>
        {/if}
    </div>


</span>
<style lang="scss">
    .input-area-view {
        display: inline-block;

        margin-top: 0.5em;
        margin-bottom: 0.5em;
        margin-right: 2em;

        .label-input-area {
            display: inline-flex;
            align-items: center;

            .label-area {

                .required-sign {
                    background-color: var(--danger-color);
                    color: var(--danger-color-text);
                    font-size: 0.7em;
                    padding-left: 0.25em;
                    padding-right: 0.25em;
                    border-radius: 4px;
                }
            }

            .input-area {
                margin-left: 12px;
                flex-grow: 1;
            }
        }

        .message-area {
            margin-top: 8px;

            .message {
                font-size: 0.5em;
                display: flex;

                .sign {
                    font-size: 1.5em;
                }

                .message {
                    white-space: pre-wrap;

                }

                &.error-message {
                    color: var(--danger-color);

                }
            }

        }

    }
</style>